export default __webpack_public_path__ + "static/media/favicon.3baeff47.ico";